module.exports = __webpack_public_path__ + "static/media/coin.c38ea02b.svg";